module.exports = __webpack_public_path__ + "img/20240918142419988g0f.bc37100b.jpg";